import { pick } from 'lodash'
import { track } from '../analytics'

const getArgs = args => {
  return pick(args, ['workspaceId', 'workspaceSlug', 'profileId'])
}

export const personasProfileViewed = args => {
  track('Personas Profile Viewed', getArgs(args))
}

export const personasProfileTabViewed = args => {
  track('Personas Profile Tab Viewed', {
    ...getArgs(args),
    type: args.type
  })
}

export const personasProfileEventsLoadedMore = args => {
  track('Personas Profile Events Loaded More', getArgs(args))
}
